/** 组件 交互 中转 */
import Vue from 'vue'
export default new Vue()